import axios, { AxiosPromise } from 'axios';
import { IAppInstallCountParams, IAttendanceParams, IEnrolledStudentParams, IExamStatsByLevelParams, IExamStatsByQuestionParams, IExamStatsByStudentParams, IExamStatsParams, IGetAppInstallCount, IGetAttendanceByClass, IGetAttendanceByStudent, IGetAttendanceSummary, IGetEnrolledStudentSummary, IGetExamLevels, IGetExamStatsByClass, IGetExamStatsByLevel, IGetExamStatsByQuestion, IGetExamStatsByStudent, IGetExamStatsSummary, IGetExamSubjects, IGetEnrolledStudentClasses, IGetPtStatsByGrade, IGetPtStatsByStudent, IGetPtStatsSummary, IGetTextList, IGetTextSummaries, IGetWebMemberCount, IPtStatsByQuestionParams, IPtStatsByStudentParams, IPtStatsParams, ITextListParams, ITextSummaryParams, IGetEnrolledStudentList, IEnrolledStudentByPeriodParams, IGetEnrolledStudentByMonth, IGetEnrolledStudentByWeek, IRetiredStudentByMonthParams, IGetRetiredStudentByMonth, IRetiredStudentParams, IGetRetiredStudents, IGetAppInstallStatsByStudent, IGetAppInstallStatsByDevice, IAppInstallStatsParams, IGetELearningSummary, IELearningParams, IGetELearningStudents, IDtttParams, IGetDtttSummary, IGetDtttStudents, IHomeworkParams, IGetHomeworkSummary, IGetHomeworkStudents, IGetArticleSummariesParams, IGetArticleSummaries, IGetArticleStudentsParams, IGetArticleStudents, IGetDtttActivitySummary, IGetHomeworkActivitySummary, IGetPBTSummary, IPBTParams, IGetPBTStudents, IGetPBTActivitySummary, IGetEnrolledStudentSchool, IGetEnrolledStudentLevel, IGetExamStatsByAnswerRate, IGetPtStatsByLevel, ICacUsageParams, IGetCacUsageReport, ICacNotViewedStudentParams, IGetCacNotViewedStudents } from '../models/statistics.model';
import { IPtStatsByGradeDetailReq, IGetPtStatsByGradeDetail, IPtStatsByStudentsDetailReq, IGetPtStatsByStudentsDetail } from '../models/statistics.model';
import QueryString from 'qs';

const uri = '/mgmt/statistics';

export const getTextSummaries = (params: ITextSummaryParams): AxiosPromise<IGetTextSummaries> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/sms/summary-list?${qsParams}`);
};

export const getTextList = (params: ITextListParams): AxiosPromise<IGetTextList> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/sms/detail-list?${qsParams}`);
};

export const getAppInstallCount = (params: IAppInstallCountParams): AxiosPromise<IGetAppInstallCount> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/app/date-list?${qsParams}`);
};

export const getAppInstallStatsByStudent = (params: IAppInstallStatsParams): AxiosPromise<IGetAppInstallStatsByStudent> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/app/student-list?${qsParams}`);
};

export const getAppInstallStatsByDevice = (params: IAppInstallStatsParams): AxiosPromise<IGetAppInstallStatsByDevice> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/app/student-list/os?${qsParams}`);
};

export const getExamStatsSummary = (examCode: number, params: IExamStatsParams): AxiosPromise<IGetExamStatsSummary> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/regular-test/summary/${examCode}?${qsParams}`);
};

export const getExamStatsSummaryByExamCodeList = (params: IExamStatsParams): AxiosPromise<IGetExamStatsSummary> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/regular-test/summary/examCodeList?${qsParams}`);
};

export const getExamStatsByLevel = (examCode: number, params: IExamStatsByLevelParams): AxiosPromise<IGetExamStatsByLevel> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/regular-test/level/${examCode}?${qsParams}`);
};

export const getExamStatsLevelByExamCodeList = (params: IExamStatsByLevelParams): AxiosPromise<IGetExamStatsByLevel> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/regular-test/level/examCodeList?${qsParams}`);
};

export const getExamStatsByClass = (examCode: number, params: IExamStatsParams): AxiosPromise<IGetExamStatsByClass> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/regular-test/class/${examCode}?${qsParams}`);
};

export const getExamStatsByStudent = (examCode: number, params: IExamStatsByStudentParams): AxiosPromise<IGetExamStatsByStudent> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/regular-test/students/${examCode}?${qsParams}`);
};

export const getExamStatsByQuestion = (examCode: number, params: IExamStatsByQuestionParams): AxiosPromise<IGetExamStatsByQuestion> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/regular-test/subject/${examCode}?${qsParams}`);
};

export const getExamStatsByAnswerRate = (examCode: number, params: IExamStatsByQuestionParams): AxiosPromise<IGetExamStatsByAnswerRate> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/regular-test/subject/answer/${examCode}?${qsParams}`);
};

export const getExamSubjects = (examCode: number): AxiosPromise<IGetExamSubjects> => {
  return axios.get(`${uri}/regular-test/${examCode}/subject-list`);
};

export const getExamLevels = (examCode: number, semesterCode: number): AxiosPromise<IGetExamLevels> => {
  return axios.get(`${uri}/regular-test/${examCode}/${semesterCode}/level-list`);
};

export const getPtStatsSummary = (examCode: number, params: IPtStatsParams): AxiosPromise<IGetPtStatsSummary> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/placement-test/summary/${examCode}?${qsParams}`);
};

export const getPtStatsSummaryByType = ( params: IPtStatsParams): AxiosPromise<IGetPtStatsSummary> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/placement-test/summary/examTypeCode?${qsParams}`);
};

export const getPtStatsByGrade = (examCode: number, params: IPtStatsParams): AxiosPromise<IGetPtStatsByGrade> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/placement-test/grade/${examCode}?${qsParams}`);
};

export const getPtStatsByGradeByType = (params: IPtStatsParams): AxiosPromise<IGetPtStatsByGrade> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/placement-test/grade/examTypeCode?${qsParams}`);
};

export const getPtStatsByStudent = (examCode: number, params: IPtStatsByStudentParams): AxiosPromise<IGetPtStatsByStudent> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/placement-test/students/${examCode}?${qsParams}`);
};

export const getPtStatsByQuestion = (examCode: number, params: IPtStatsByQuestionParams): AxiosPromise<IGetExamStatsByQuestion> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/placement-test/subject/${examCode}?${qsParams}`);
};

export const getPtStatsByLevelByType = (params: IPtStatsParams): AxiosPromise<IGetPtStatsByLevel> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/placement-test/level/examTypeCode?${qsParams}`);
};

export const getAttendanceSummary = (params: IAttendanceParams): AxiosPromise<IGetAttendanceSummary> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/attend/summary?${qsParams}`);
};

export const getAttendanceByClass = (params: IAttendanceParams): AxiosPromise<IGetAttendanceByClass> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/attend/classes?${qsParams}`);
};

export const getAttendanceByStudent = (params: IAttendanceParams): AxiosPromise<IGetAttendanceByStudent> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/attend/students?${qsParams}`);
};

export const getWebMemberCount = (params: {campusCode: string[], srtDate: string, endDate: string }): AxiosPromise<IGetWebMemberCount> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/web-join?${qsParams}`);
};

export const getEnrolledStudentSummary = (params: IEnrolledStudentParams): AxiosPromise<IGetEnrolledStudentSummary> => {
  return axios.get(`${uri}/register-student/summary`, { params });
};

export const getEnrolledStudentClasses = (params: IEnrolledStudentParams): AxiosPromise<IGetEnrolledStudentClasses> => {
  return axios.get(`${uri}/register-student/class`, { params });
};

export const getEnrolledStudentList = (params: IEnrolledStudentParams): AxiosPromise<IGetEnrolledStudentList> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/register-student/student-list?${qsParams}`);
};

export const getEnrolledStudentByMonth = (params: IEnrolledStudentByPeriodParams): AxiosPromise<IGetEnrolledStudentByMonth> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/register-student/monthly?${qsParams}`);
};

export const getEnrolledStudentByWeek = (params: IEnrolledStudentByPeriodParams): AxiosPromise<IGetEnrolledStudentByWeek> => {
  return axios.get(`${uri}/register-student/weekly`, { params });
};

export const getEnrolledStudentSchool = (params: IEnrolledStudentParams): AxiosPromise<IGetEnrolledStudentSchool> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/register-student/school?${qsParams}`);
};

export const getEnrolledStudentLevel = (params: IEnrolledStudentParams): AxiosPromise<IGetEnrolledStudentLevel> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/register-student/level?${qsParams}`);
};

export const getRetiredStudentByMonth = (params: IRetiredStudentByMonthParams): AxiosPromise<IGetRetiredStudentByMonth> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/retire-students/monthly?${qsParams}`);
};

export const getRetiredStudents = (params: IRetiredStudentParams): AxiosPromise<IGetRetiredStudents> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/retire-students/students?${qsParams}`);
};

export const getELearningSummary = (params: IELearningParams): AxiosPromise<IGetELearningSummary> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/e-learning/summary?${qsParams}`);
};

export const getELearningStudents = (params: IELearningParams): AxiosPromise<IGetELearningStudents> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/e-learning/student-list?${qsParams}`);
};

export const getDtttSummary = (params: IDtttParams): AxiosPromise<IGetDtttSummary> => {
  return axios.get(`${uri}/dttt/summary`, { params });
};

export const getDtttStudents = (params: IDtttParams): AxiosPromise<IGetDtttStudents> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/dttt/student-list?${qsParams}`);
};

export const getDtttActivitySummary = (params: IDtttParams): AxiosPromise<IGetDtttActivitySummary> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/dttt/activity-summary?${qsParams}`);
};

export const getHomeworkSummary = (params: IHomeworkParams): AxiosPromise<IGetHomeworkSummary> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/homework/summary?${qsParams}`);
};

export const getHomeworkStudents = (params: IHomeworkParams): AxiosPromise<IGetHomeworkStudents> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/homework/student-list?${qsParams}`);
};

export const getHomeworkActivitySummary = (params: IHomeworkParams): AxiosPromise<IGetHomeworkActivitySummary> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/homework/activity-summary?${qsParams}`);
};

export const getArticleSummaries = (params: IGetArticleSummariesParams): AxiosPromise<IGetArticleSummaries> => {
  return axios.get(`${uri}/articles/summary`, { params });
};

export const getArticleStudents = (params: IGetArticleStudentsParams): AxiosPromise<IGetArticleStudents> => {
  return axios.get(`${uri}/articles/list`, { params });
};

export const getPtStatsByGradeDetail = (params: IPtStatsByGradeDetailReq): AxiosPromise<IGetPtStatsByGradeDetail> => {
  return axios.get(`${uri}/placement-test/gradeDetail`, { params });
};

export const getPtStatsByStudentsDetail = (params: IPtStatsByStudentsDetailReq): AxiosPromise<IGetPtStatsByStudentsDetail> => {
  //return axios.get(`${uri}/placement-test/studentsDetail${params.eduStepCode}`, { params });
  return axios.get(`${uri}/placement-test/studentsDetail${params.eduStepCode}`, { params });
};

export const getPBTSummary = (params: IPBTParams): AxiosPromise<IGetPBTSummary> => {
  return axios.get(`${uri}/pbt/summary`, { params });
};

export const getPBTStudents = (params: IPBTParams): AxiosPromise<IGetPBTStudents> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/pbt/student-list?${qsParams}`);
};

export const getPBTActivitySummary = (params: IPBTParams): AxiosPromise<IGetPBTActivitySummary> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/pbt/activity-summary?${qsParams}`);
};

/** CAC 활용 통계 (담임/캠퍼스/직영·가맹/종합) — POST + JSON (쿼리스트링 비노출) */
export const getCacUsageReport = (
  params: ICacUsageParams,
): AxiosPromise<IGetCacUsageReport> =>
  axios.post(`${uri}/cac/usage`, params);

/** CAC 아무도 조회하지 않은 학생 목록 — POST + JSON */
export const getCacNotViewedStudents = (
  params: ICacNotViewedStudentParams,
): AxiosPromise<IGetCacNotViewedStudents> =>
  axios.post(`${uri}/cac/not-viewed-students`, params);